import { useEffect, useState } from "react";
import { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../../../common/store/combinedReducer";
import "../../dashboardDetails.scss";
import "../css/dataManagement.scss";
import { Breadcrumb, Icon, Loader, Tooltip } from "@scuf/common";
import {
  setSelectedView,
  gettabledata,
  blobSizeDashboard,
  setDeleteDataManagementRecord,
  getDashboardUploadValidationApi,
  setDashboardUploadValidationApi,
  deleteDataManagementRecord,
  setLoading,
  getCSRFToken,
  getDetails,
  getPermissions,
  setCSRFToken,
  setLoggedIn,
  settabledata,
  setSearchList,
  getSearchData,
} from "../../../../store/action";
import "@scuf/datatable/honeywell-dark/theme.css";

import { Progress } from "@scuf/common";
import "react-toastify/dist/ReactToastify.css";
import { customToast } from "../../../../../App";
import _, { set } from "lodash";
import { sha256HashFile } from "../../../../../common/utility/shaHash";
import {
  IFile,
  ISelectedRowDataStruc,
  ISelectedRowDownloadStruc,
} from "../../../../models/dataManagement.model";
import { DeleteFilePopup } from "./popup-windows/DeleteFilePopup";
import { FileExistPopup } from "./popup-windows/FileExistPopup";
import { FileValidatePopup } from "./popup-windows/FileValidatePopup";
import { FolderNotEmptyPopup } from "./popup-windows/FolderNotEmptyPopup";
import { SymlinkErrorPopup } from "./popup-windows/SymlinkErrorPopup";
import { NameLengthExceededPopup } from "./popup-windows/NameLengthExceeded";
import { useNavigate } from "react-router-dom";
import HeaderComponent from "../../../header/header";
import AuthProvider from "../../../../../common/authentication/authService";
import { UploadNotePopup } from "./popup-windows/uploadNotesPopup";
import {
  cancelUploadAPiCall,
  commitChunkApiAxios,
  chunkAPIAxios,
} from "../../../../../common/dataManagementAxiosCalls/axiosDmCalls";
import { DataManagementGridNew } from "./data-management-grid/DataManagementGridNew";
import { cookieVal } from "../../../../store/service";
import { downloadRecordsFetchCall } from "../../../../../common/dataManagementAxiosCalls/fetchDmCalls";
import {
  processDownloadedChunk,
  getFormattedDateTime,
  blobFlow,
  verifyFile,
} from "../../../../../common/utility/dataManagementUtils";
import { handleRefresh } from "../../../../../common/utility/Dashboard/utility";

const chunkSize = 5 * 1024 * 1024;

export default function DataManagement() {
  const siteId = useSelector((state: AppState) => {
    return state.reducer.selectedPlant;
  });
  const siteid = useRef("");
  const activePage = useSelector((state: AppState) => {
    return state.reducer.activePage;
  });
  const tdata = useSelector((state: AppState) => {
    return state.reducer?.tableData;
  });

  //Blob Size
  const blobSize = useSelector((state: AppState) => {
    return state.reducer?.blobSizeDashboard;
  });
  const deleteApiRes = useSelector((state: any) => {
    return state.reducer?.deleteDashboardRes;
  });
  const downLoadApiRes = useSelector((state: any) => {
    return state.reducer;
  });
  const uploadApiValidation = useSelector((state: any) => {
    return state?.reducer?.uploadValidationRes;
  });
  const userDetail: any = useSelector((state: AppState) => {
    return state.reducer.userInfo;
  });
  const selectedPlant = useSelector((state: AppState) => {
    return state.reducer.selectedPlant;
  });
  const orgDataStatus = useSelector((state: AppState) => {
    return state.reducer.orgDataStatus;
  });
  const searchStatus = useSelector((state: AppState) => {
    return state.reducer.searchStatus;
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [selectedRow, setSelectedRow] = useState<IFile[]>([]);
  // const [pathcount, setPathcount] = useState(0);
  const [selectedRowData, setSelectedRowData] = useState<
    ISelectedRowDataStruc[]
  >([]);
  const [downloadSelectedRowData, setDownloadSelectedRowData] = useState<
    ISelectedRowDownloadStruc[]
  >([]);

  // temp changes
  const [xval, setxval] = useState<any>([]);
  const [blobSizeState, setBlobSizeState] = useState<any>(0);
  const [finallist, setuniqList] = useState<any>([]);
  const [deletePopOpen, setDeleteOpen] = useState(false);
  const [loading, setLoadingPage] = useState(false);
  const [newFileKey, setfileKey] = useState("");
  const [disablefunc, setDisablefunc] = useState(true);
  const [disablefuncupload, setDisablefuncUpload] = useState(false);
  const [fileNameUpload, setFileNameUpload] = useState<any>("");
  const [uploadValidateOpen, setUploadValidateOpen] = useState(false);
  const [newArr, setNewArr] = useState<any>([]);
  const [fexist, setFexist] = useState(false);
  const [downHandelClick, setDownHandelClick] = useState(false);
  const inputEle = useRef<any>("");
  const [consumedBlobState, setConsumedBlobState] = useState<any>(0);
  const [emptyFldrName, setemptyFldrName] = useState(false);
  const [nameLength, setNameLength] = useState(false);
  const [orgNameVal, setOrgName] = useState("");
  const [showProgress, setShowProgress] = useState(false);
  const [progress, setProgress] = useState(0);
  const [fileSize, setFileSize] = useState(0);
  const [showRetry, setShowRetry] = useState(false);
  const [counter, setCounter] = useState(1);
  const [retryCount, setRetryCount] = useState(1);
  const [selectedLargeFile, setSelectedLargeFile] = useState<any>(null);
  const [startFileUpload, setStartFileUpload] = useState(false);
  const [showReset, setShowReset] = useState(false);
  const [downloadInPRogress, setDownloadInPRogress] = useState(false);
  const [fileHash, setFileHash] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const searchData = useRef("");
  const searchError = useRef(false);
  const rowKey = useRef("");
  const chunkCount = useRef(0);
  const stopUpload = useRef(false);
  const [symlinkError, setSymlinkError] = useState(false);
  const [isNewFolderBtnDisabled, setIsNewFolderBtnDisabled] =
    useState<boolean>(false);

  // search
  const [filteredGridData, setFilteredGridData] = useState<any[]>([]);
  const [isSearchDataEmpty, setIsSearchDataEmpty] = useState<boolean>(true);
  const [orgId, setOrgId] = useState("");

  // download
  const [showDownloadProgress, setDownloadProgress] = useState(false);
  const [progressDownload, setProgressDownload] = useState(0);
  const [retryCountDownload, setRetryCountDownload] = useState(0);
  const [retryBtnState, hideRetryBtnState] = useState(true);
  const [chunks, setChunks] = useState<any>([]);
  const [receivedLength, setReceivedLength] = useState(0);
  const [contentLength, setContentLength] = useState(0);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [showPopup, setShowPopup] = useState(false);
  var final: any = "";

  const permissions = useSelector((state: AppState) => {
    return state.reducer.permissions;
  });
  const plantName = useSelector((state: AppState) => {
    return state.reducer.plantName;
  });
  const csrf = useSelector((state: AppState) => {
    return state.reducer.csrf;
  });
  const csrfStatus = useSelector((state: AppState) => {
    return state.reducer.csrfStatus;
  });
  const permissionStatus = useSelector((state: AppState) => {
    return state.reducer.permissionStatus;
  });
  const searchList = useSelector((state: AppState) => {
    return state.reducer.searchList;
  });
  const orgData = useSelector((state: AppState) => {
    return state.reducer.orgData;
  });
  useEffect(() => {
    if (
      permissions?.length > 0 &&
      localStorage.getItem("access_token") !== undefined &&
      permissionStatus !== 500
    ) {
      if (orgDataStatus === 0) {
        fetchDetails(selectedPlant);
      } else if (orgDataStatus !== 0) {
        dispatch(setLoggedIn(false));
      }
    } else if (
      permissionStatus !== 0 &&
      (permissions === null ||
        (permissions?.length <= 0 &&
          localStorage.getItem("access_token") !== undefined) ||
        permissionStatus === 500)
    ) {
      dispatch(setLoggedIn(false));
      navigate("/loginFailed");
    }
  }, [permissions, orgDataStatus]);

  const fetchDetails = (orgs: any) => {
    setLoadingPage(true);
    dispatch(
      getDetails({ authorization: localStorage.getItem("access_token"), orgs })
    );
    getData();
    dispatch(setLoggedIn(true));
    const orgNameData: any = _.find(permissions, ["resources", siteId]);
    if (orgNameData && orgNameData.resourceName) {
      setOrgName(orgNameData.resourceName);
    } else {
      orgNameData && setOrgName(orgNameData.resources);
    }
    const val = orgData[0]?.id?.split(":");
    val && val.length > 0 && setOrgId(val[val?.length - 1]);
    setConsumedBlobState(0);
  };

  useEffect(() => {
    if (csrfStatus === 200 || csrfStatus !== 0) {
      const sub: any = AuthProvider().getUserId();
      dispatch(setLoading(false));
      dispatch(setCSRFToken({ status: 0, data: false }));
      if (sub && csrf === true && permissions?.length === 0) {
        dispatch(
          getPermissions({
            userSub: sub,
            authorization: localStorage.getItem("access_token"),
          })
        );
      } else if (csrf === false) {
        setTimeout(() => {
          navigate("/loginFailed");
        }, 500);
      } else {
        dispatch(setLoading(false));
      }
    } else if (csrfStatus !== 200 && csrfStatus !== 0) {
      setTimeout(() => {
        navigate("/loginFailed");
      }, 500);
    }
  }, [csrfStatus, csrf]);

  // function handleRefresh(isRefreshed: boolean) {
  //   if (isRefreshed === true) AuthProvider().clearCookie("XSRF-TOKEN");
  //   AuthProvider()
  //     .getRefreshToken()
  //     .then((resp: any) => {
  //       const tokenData = resp?.access_token;
  //       if (tokenData && resp && isRefreshed === true) {
  //         dispatch(
  //           getCSRFToken({
  //             authorization: localStorage.getItem("access_token"),
  //           })
  //         );
  //       }
  //     });
  // }
  useEffect(() => {
    siteid.current = siteId;
  }, [siteId]);
  useEffect(() => {
    if (
      localStorage.getItem("logged_user") === null ||
      localStorage.getItem("logged_user") === JSON.stringify(false)
    ) {
      localStorage.setItem("logged_out_from", "datamanagement /");

      navigate("/");
    } else {
      localStorage.setItem("logged_user", JSON.stringify(true));
      const selectedViewVal = {
        selectedView: "DataManagement",
        plantName,
        activePage,
      };
      dispatch(setSelectedView(selectedViewVal));
      if (permissions?.length === 0) {
        dispatch(setLoading(true));
        handleRefresh(true, dispatch);
      }
      const orgNameData: any = _.find(permissions, ["resources", siteId]);
      if (orgNameData && orgNameData.resourceName) {
        setOrgName(orgNameData.resourceName);
      } else {
        orgNameData && setOrgName(orgNameData.resources);
      }
      setConsumedBlobState(0);
      if (selectedPlant !== "") {
        fetchDetails(selectedPlant);
      }
      const handleKeyDown = (event: KeyboardEvent) => {
        if (event.key === "Enter") {
          // You may need to cast to the correct type if your handler expects a KeyboardEvent<HTMLInputElement>
          handleSearchInput(
            event as unknown as React.KeyboardEvent<HTMLInputElement>
          );
        }
      };
      window.addEventListener("keydown", handleKeyDown);
      return () => {
        window.removeEventListener("keydown", handleKeyDown);
      };
    }
  }, []);

  useEffect(() => {
    setSearchValue(searchValue);
    searchData.current = searchValue;
  }, [searchValue]);
  useEffect(() => {
    if (orgDataStatus !== 0) {
      dispatch(setLoading(false));
      setLoadingPage(false);
    }
  }, [orgDataStatus]);

  async function getData() {
    let data = {
      siteId,
      // page: 0,
      // pageSize: 10000, // TODO: Need to change this to property
      // parentPath: `%2F`
      parentPath: `${finallist.join("/")}`,
    };
    // setuniqList([]);
    if ((xval === null || xval?.length === 0) && siteId)
      dispatch(gettabledata(data));

    let currentPath = `${finallist.join("/")}`;
    let folders = new Set();
    var paginatedData = xval?.filter((item: any) => {
      if (item.path === currentPath || item.path === undefined) {
        //item.path = undefined;
        item.fullPath = item.path + "/" + item.fileName;
        return item;
      } else {
        let currFolder = item.path.replace(
          new RegExp(`^${currentPath}\\s*`),
          ""
        );
        let _currTopLevelFolder = currFolder.split("/").filter(Boolean)[0];
        if (!folders.has(_currTopLevelFolder)) {
          folders.add(_currTopLevelFolder);
          item.fileType = "folder";
          //item.fileName=undefined;
          return item;
        }
      }
    });

    setFilteredGridData(paginatedData);
    if (siteId) {
      dispatch(
        blobSizeDashboard({
          authorization: localStorage.getItem("access_token"),
          container: siteId,
        })
      );
    }
  }

  useEffect(() => {
    CheckForUploadInprogress();
    checkIfResetRender();
    setFilteredGridData([]);
    //var paginatedData = xval?.slice(0, allowTableRowPerPage)

    let currentPath = `${finallist.join("/")}`; //TODO: bring this all into one function for code reuse
    let folders = new Set();
    var paginatedData = xval?.filter((item: any) => {
      if (item.path === currentPath || item.path === undefined) {
        //item.path = undefined;
        item.fullPath = item.path + "/" + item.fileName;
        return item;
      } else {
        let currFolder = item.path.replace(
          new RegExp(`^${currentPath}\\s*`),
          ""
        );
        let _currTopLevelFolder = currFolder.split("/").filter(Boolean)[0];
        if (!folders.has(_currTopLevelFolder)) {
          folders.add(_currTopLevelFolder);
          item.fileType = "folder";
          return item;
        }
      }
    });
    setLoading(false);
    setFilteredGridData(paginatedData);
  }, [xval]);

  useEffect(() => {
    if (startFileUpload && fileNameUpload !== "" && selectedLargeFile) {
      uploadFile();
      setShowReset(true);
      // setPreventUplaod(true);
    }
  }, [startFileUpload, fileNameUpload, selectedLargeFile]);

  const dateFormatFun = (utcDate: any) => {
    const options: any = {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    };
    const formatted = new Date(utcDate).toLocaleDateString("en-US", options);
    const dateParts = formatted
      .substring(0, formatted.indexOf(","))
      .split(" ")
      .reverse()
      .join(" ");
    // Return the formatted date with uppercase month abbreviation and desired format
    const formattedDate =
      dateParts + formatted.substr(formatted.indexOf(",") + 1);
    return formattedDate;
  };

  const checkIfResetRender = () => {
    var tempxval =
      xval?.length > 0
        ? xval.filter((item: any) => {
            return (
              item.status === "FILE_UPLOAD_INPROGRESS" &&
              item.updatedBy === userDetail.email
            );
          })
        : [];
    //write logic to get email id

    if (tempxval.length > 0) {
      setShowReset(true);
      // setPreventUplaod(true);
    }
  };

  const navigateToPreviousPage = (pageName: any, datax: any, index: any) => {
    if (
      pageName != null &&
      pageName != undefined &&
      !showDownloadProgress &&
      !showProgress
    ) {
      // let index = finallist?.indexOf(pageName)
      finallist?.splice(index + 1, finallist?.length - index + 1);
      let previousfinal = finallist?.join("/");
      // setCurrentPage(0);
      let data = {
        siteId,
        // page: 0,
        // pageSize: 10000,
        parentPath: `${previousfinal}`,
      };
      setLoadingPage(true);
      dispatch(gettabledata(data));
    }
  };

  const navigateToDatamanagement = (jsonData: any) => {
    if (
      jsonData != null &&
      jsonData != undefined &&
      !showDownloadProgress &&
      !showProgress
    ) {
      // dispatch(
      //   settabledata({
      //     totalrecords: 0,
      //     message: [],
      //     error: null,
      //     status: "Files Retrieved",
      //     statuscode: 200,
      //   })
      // );
      // setCurrentPage(0);
      setLoadingPage(true);
      finallist?.splice(0, finallist?.length);
      setuniqList([...finallist]);
      // handlepagination(1)
      let data = {
        siteId,
        // page: 0,
        // pageSize: 10000,
        // parentPath: `%2F`
        parentPath: `${finallist.join("/")}`,
      };
      dispatch(gettabledata(data));

      setxval(jsonData);
    }
  };

  const CheckForUploadInprogress = () => {
    //write logic to get the email id
    var tempxval =
      xval?.length > 0
        ? xval.filter((item: any) => {
            return (
              item.updatedBy === userDetail.email &&
              item.status === "FILE_UPLOAD_INPROGRESS"
            );
          })
        : [];
    //write logic to get email id
    if (tempxval.length > 0) {
      setFileNameUpload(tempxval[0].fileName);
    }
  };

  const navigateToDashboard = async (plantName: string) => {
    if (!showDownloadProgress && !showProgress) {
      navigate("/dashboard");
      // setFilteredGridData(_filteredData);
      setIsSearchDataEmpty(true);
      dispatch(setSearchList({ message: [], statuscode: 0 }));
      stopUpload.current = true;
    }
  };

  useEffect(() => {
    if (tdata?.statuscode === 200) {
      // const checkdownload = cancelTheDownloadIfUserRefresh(tdata?.message);
      // if (checkdownload === null) {
      let result = tdata?.message.map((item: any, index: number) => {
        return {
          ...item,
          updatedAt: dateFormatFun(item.updatedAt)
            ? dateFormatFun(item.updatedAt)
            : "",
        };
      });
      setSelectedRow([]);
      setxval(result);
      CheckForUploadInprogress();
      setLoadingPage(false);
      setDisablefunc(true);
      setDisablefuncUpload(false);
    } else if (tdata?.statuscode !== 0) {
      setLoadingPage(false);
    }
    // }
  }, [tdata]);

  useEffect(() => {
    setBlobSizeState(blobSize);
    // const convertDataGB = (val: any, type: any) => {
    //   let gbVal;
    //   if (type?.toLowerCase() === "kb") {
    //     gbVal = val / 1024 / 1024;
    //   }
    //   if (type?.toLowerCase() === "mb") {
    //     gbVal = val / 1024;
    //   }
    //   return gbVal;
    // };
    // function splitFun(input: any) {
    //   const splitArray = input.match(/([\d\.]+)(.*)/);
    //   return {
    //     numeric: splitArray[1],
    //     nonnumeric: splitArray[2],
    //   };
    // }
    // const blobFlow = async () => {
    //   if (blobSize?.message?.consumedSize === "0Bytes") {
    //     setConsumedBlobState(0);
    //   } else if (blobSize?.message?.consumedSize) {
    //     let consize = splitFun(blobSize?.message?.consumedSize);
    //     if (consize.nonnumeric.toLowerCase() !== "gb") {
    //       let resConsume = convertDataGB(consize.numeric, consize.nonnumeric);
    //       if (resConsume) {
    //         // let roundNum = Math.round(resConsume);
    //         setConsumedBlobState(resConsume);
    //       }
    //     } else {
    //       if (consize.numeric) {
    //         setConsumedBlobState(consize.numeric);
    //       }
    //     }
    //   }
    // };
    blobFlow(blobSize, setConsumedBlobState);
  }, [blobSize]);

  let allosize = blobSizeState?.message?.allocatedSize;

  const AllocatedSize = parseInt(allosize?.slice(0, allosize?.length - 2));

  useEffect(() => {
    function getDataVal() {
      //Handle Delete api response
      if (deleteApiRes != null && !Array.isArray(deleteApiRes)) {
        if (
          deleteApiRes?.status === 200 ||
          deleteApiRes?.data?.statuscode === 200
        ) {
          setLoadingPage(false);

          let data = {
            siteId,
            // page: 0,
            // pageSize: 10000,
            // parentPath: "%2F"
            parentPath: `${finallist.join("/")}`,
          };
          // setuniqList([]);
          customToast(
            deleteApiRes?.data?.message === null
              ? deleteApiRes?.data?.status
              : deleteApiRes?.data?.message,
            "success"
          );
          dispatch(setDeleteDataManagementRecord(null));
          dispatch(gettabledata(data));
          dispatch(
            blobSizeDashboard({
              authorization: localStorage.getItem("access_token"),
              container: siteId,
            })
          );
          setDisablefunc(true);
          setDisablefuncUpload(false);
          setSelectedRow([]);
        }
      }
    }
    getDataVal();
  }, [deleteApiRes]);

  useEffect(() => {
    function getDataUpload() {
      if ("setDownloadRes" in downLoadApiRes === true) {
        // setDom(!dom);
        setLoadingPage(false);
      }
      if (uploadApiValidation?.status === 200) {
        setLoadingPage(false);
        if (uploadApiValidation.data?.statuscode === 200) {
          setLoadingPage(false);
          setUploadValidateOpen(true);
          rowKey.current = uploadApiValidation.data?.data?.rowKey;
          dispatch(setDashboardUploadValidationApi(null));
        } else if (uploadApiValidation.data?.statuscode === 400) {
          setLoadingPage(false);
          setUploadValidateOpen(false);
          setStartFileUpload(true);
          dispatch(setDashboardUploadValidationApi(null));
        }
      }
    }
    getDataUpload();
  }, [
    uploadApiValidation?.status ||
      uploadApiValidation ||
      downLoadApiRes ||
      tdata?.statuscode,
  ]);

  function handlechangelink(datas: any, datax: any) {
    // dispatch(
    //   settabledata({
    //     totalrecords: 0,
    //     message: [],
    //     error: null,
    //     status: "Files Retrieved",
    //     statuscode: 200,
    //   })
    // );
    let currentPath = `${finallist.join("/")}/`;
    let currFolders = datas?.path.replace(
      new RegExp(`^${currentPath}\\s*`),
      ""
    );
    let currTopLevelFolder = currFolders.split("/").filter(Boolean)[0];
    if (currTopLevelFolder === undefined || currTopLevelFolder === "") {
      currTopLevelFolder = currFolders;
    }
    finallist.push(currTopLevelFolder);
    final = finallist.join("/");
    // setCurrentPage(0);
    let data = {
      siteId,
      // page: 0,
      // pageSize: 10000,
      parentPath: `${final}`,
    };
    setLoadingPage(true);
    dispatch(gettabledata(data));
  }

  // upload File
  // const uploadValidationPopupEvent = (event: any) => {
  //   resetFileInput();
  //   rowKey.current = "";
  //   event.preventDefault();
  //   setUploadValidateOpen(false);
  //   setFileNameUpload("");
  //   return;
  // };
  // const filealreadyexistEvent = () => {
  //   setFexist(false);
  //   inputEle.current.focus();
  // };
  // // Folder Name can not be empty
  // const folderNameCantBeEmptyEvent = () => {
  //   setemptyFldrName(false);
  //   inputEle.current.focus();
  // };
  // const nameLengthEvent = () => {
  //   setNameLength(false);
  //   resetChunkProperties();
  // };
  // Refresh Button Functionality
  const refreshCurrentPageOfTable = async () => {
    setLoadingPage(true);
    let data = {
      siteId,
      // page: 0,
      // pageSize: 10000,
      // parentPath: "%2F"
      parentPath: `${finallist.join("/")}`,
    };
    // setuniqList([]);
    dispatch(gettabledata(data));
    dispatch(
      blobSizeDashboard({
        authorization: localStorage.getItem("access_token"),
        container: siteId,
      })
    );
  };
  //Symlink Error
  const handleSymlinkErrorPopup = (event: any) => {
    event.preventDefault();
    setSymlinkError(false);
  };

  const resetChunkProperties = () => {
    setProgressDownload(0);
    setDisablefuncUpload(false);
    setDownloadInPRogress(false);
    setShowProgress(false);
    setProgress(0);
    setStartFileUpload(false);
    stopUpload.current = false;
    setDownloadProgress(false);
    //counter = 1;
    // rowKey = "";
    setCounter(1);
    setShowRetry(false);
    rowKey.current = "";
    setFileSize(0);
    setRetryCount(1);
    setSelectedLargeFile(null);
    // setPreventUplaod(false);
    setShowReset(false);
    // setShowUploadAndScanMsg(false);
    chunkCount.current = 0;
    resetFileInput();
  };

  const resetFileInput = () => {
    var fileInput = document.getElementById("browse-file") as HTMLInputElement;
    fileInput.value = "";
  };

  const handleDeleteApiFinalCall = () => {
    setLoadingPage(false);
    setDeleteOpen(false);

    setLoadingPage(true);

    const result = selectedRowData.map((item: any, index: number) => {
      //prepare delete based on selection and ui search status
      let _path = "";
      let _fileName = "";
      if (!isSearchDataEmpty) {
        _fileName = item.fileName;
        _path = item.path;
      } else if (item.fileType === "folder") {
        let currentPath = `${finallist.join("/")}/`;
        let currFolder = item.path.replace(
          new RegExp(`^${currentPath}\\s*`),
          ""
        );
        let _currTopLevelFolder = currFolder.split("/").filter(Boolean)[0];
        _path = (currentPath !== "/" ? currentPath : "") + _currTopLevelFolder;
      }
      if (item.fileType !== "folder") {
        _fileName = item.fileName;
        _path = item.path;
      }
      return {
        fileName: _fileName,
        path: _path,
        rowKey: item.rowKey ? item.rowKey : "", // Checked API not being used in backend !!!
        partitionKey: item.partitionKey ? item.partitionKey : "", // Checked API not being used in backend !!!
      };
    });

    const data = {
      container: selectedRowData[0].containerName
        ? selectedRowData[0].containerName
        : "",
      updatedBy: userDetail.email,
      deleteModel: result,
    };
    dispatch(
      deleteDataManagementRecord({
        authorization: localStorage.getItem("access_token"),
        siteid: siteId,
        param: data,
      })
    );
  };

  // const verifyFile = (file: any) => {
  //   var maxFileSize = 2147483648;
  //   if (file.size > maxFileSize) {
  //     customToast(
  //       "File Size Is Exceeding 2GB. Please Upload A File Smaller Than 2GB.",
  //       "critical"
  //     );
  //     return false;
  //   }
  //   //Symlink code
  //   if (
  //     file.type === "application/x-symlink" ||
  //     file.type === "application/x-hardlink"
  //   ) {
  //     setSymlinkError(true);
  //     return false;
  //   }
  //   return true;
  // };

  const handleConfirmUpload = () => {
    setShowPopup(false);
    fileInputRef.current?.click();
  };

  //Event Before Upload api
  const eventBeforeUploadApi = async (event: any) => {
    setShowPopup(false);
    if (event?.target?.files?.length > 0) {
      setLoadingPage(true);
      var File = event.target.files;
      const _file = File[0];
      const parentPath: any = `${finallist.join("/")}`;
      const pathName: any = parentPath + "/" + File[0].name;
      const fileName = File[0].name;
      setFileNameUpload(fileName);
      const continueDownload = verifyFile(_file, setSymlinkError);
      if (
        continueDownload &&
        fileName.length <= 100 &&
        pathName.length <= 247
      ) {
        const data: any = {
          siteid: siteId,
          filename: File[0].name,
          parentPath: `${finallist.join("/")}`,
        };

        const createdFileHash = await sha256HashFile(_file);

        setFileHash(createdFileHash);
        dispatch(
          getDashboardUploadValidationApi({
            authorization: localStorage.getItem("access_token"),
            params: data,
            siteid: siteId,
          })
        );

        setFileSize(_file.size);
        setFileNameUpload(_file.name);
        const _totalCount =
          _file.size % chunkSize == 0
            ? _file.size / chunkSize
            : Math.floor(_file.size / chunkSize) + 1; // Total count of chunks will have been upload to finish the file
        chunkCount.current = _totalCount;
        setSelectedLargeFile(_file);
      } else if (fileName.length > 100) {
        setLoadingPage(false);
        setNameLength(true);
        customToast(
          `Filename exceeded more than 100 character. Please rename the file.`,
          "critical"
        );
      } else if (pathName.length > 247) {
        setLoadingPage(false);
        setNameLength(true);
        customToast(
          `Filepath exceeded more than 247 character. Please reduce the file name.`,
          "critical"
        );
      } else {
        setLoadingPage(false);
        resetChunkProperties();
      }
    } else {
      setLoadingPage(false);
    }
  };

  const resetFileUpload = async () => {
    setLoadingPage(true);
    if (!downloadInPRogress || showRetry) {
      try {
        await cancelUploadAPiCall(siteId);
        setShowReset(false);
        // setPreventUplaod(false);
        let data = {
          siteId,
          // page: 0,
          // pageSize: 10000,
          parentPath: `${finallist.join("/")}`,
        };

        dispatch(gettabledata(data));
        resetChunkProperties();
      } catch (error) {
        setLoadingPage(false);
      }
    } else {
      // setShowRetry(false);
      resetChunkProperties();
      setShowReset(false);
      setLoadingPage(false);
      stopUpload.current = true;
    }
  };

  const cancelTheDownloadIfUserRefresh = (data: any[]) => {
    const tempxval =
      data?.length > 0
        ? data.filter((item: any) => {
            return (
              item.updatedBy === userDetail.email &&
              item.status === "FILE_UPLOAD_INPROGRESS"
            );
          })
        : [];
    if (tempxval.length > 0 && userDetail.email === tempxval[0].updatedBy) {
      if (siteId) {
        cancelUploadAPiCall(siteId);
        setTimeout(() => {
          window.location.reload();
        }, 2000);
        return siteId;
      }
    }
    return null;
  };

  const uploadFile = async () => {
    // setPreventUplaod(true);
    setUploadValidateOpen(false);
    setDownloadInPRogress(true);
    if (selectedLargeFile) {
      setShowReset(true);
      setShowRetry(false);
      setProgress(0);
      setShowProgress(true);
      // setShowUploadAndScanMsg(true);

      const totalChunks = chunkCount.current;

      for (
        let currentChunk = counter;
        currentChunk <= totalChunks;
        currentChunk++
      ) {
        if (stopUpload.current) {
          // resetChunkProperties();
          await cancelUploadAPiCall(siteId);
          setShowReset(false);
          let data = {
            siteId,
            // page: 0,
            // pageSize: 10000,
            parentPath: `${finallist.join("/")}`,
          };
          dispatch(gettabledata(data));
          resetChunkProperties();
          break;
        }
        const startOfTheChunk = (currentChunk - 1) * chunkSize;
        const endOfTheChunk = startOfTheChunk + chunkSize;

        const chunk = selectedLargeFile.slice(startOfTheChunk, endOfTheChunk);
        try {
          setCounter(currentChunk);
          var chunkAPIResponse: any = await chunkAPIAxios(
            chunk,
            currentChunk,
            fileNameUpload,
            fileSize,
            finallist,
            rowKey,
            fileHash,
            siteId
          );

          if (chunkAPIResponse && chunkAPIResponse.status === 400) {
            setShowProgress(false);
            setShowReset(false);
            resetChunkProperties();
            customToast(
              "Already a file upload is in progress. Please try after sometime.",
              "critical"
            );
            break;
          }
          var percentage = (currentChunk / chunkCount.current) * 100;
          if (currentChunk === totalChunks) {
            // await commitChunkApi();
            await commitChunkApiAxios(fileNameUpload, fileSize, rowKey, siteId);
            resetChunkProperties();
            setProgress(100);
            if (fileNameUpload.endsWith(".zip")) {
              customToast(
                `${fileNameUpload} Uploaded!. The uploaded file might take up to an hour to reflect on the grid. Unzip the file only after moving the file to the designated Experion node.`,
                "success"
              );
            } else customToast(`${fileNameUpload} Uploaded!`, "success");
            break;
          }
          setProgress(percentage);
        } catch (uploadError: any) {
          if (uploadError !== null) {
            if (uploadError?.response?.status === 507) {
              setShowProgress(false);
              setShowReset(false);
              resetChunkProperties();
              customToast(
                `File ${fileNameUpload} upload failed. Reason: Storage space exceeds the limit of ${blobSizeState?.message?.allocatedSize}`,
                "critical"
              );
              break;
            } else if (
              retryCount <= 4 &&
              uploadError?.response?.data !==
                "File upload is already in progress!" &&
              !_.includes(
                uploadError?.response?.data,
                "character is more than 100"
              )
            ) {
              // Retry logic
              setShowRetry(true);
              setRetryCount(retryCount + 1);
              customToast(
                `${fileNameUpload} Upload Failed! Please Retry.`,
                "critical"
              );
              break;
            } else if (
              uploadError?.response?.data ===
              "File upload is already in progress!"
            ) {
              setShowProgress(false);
              setShowReset(false);
              resetChunkProperties();
              customToast(`File upload is already in progress!`, "critical");
              break;
            } else if (
              _.includes(
                uploadError?.response?.data,
                "character is more than 100"
              )
            ) {
              setShowProgress(false);
              setShowReset(false);
              resetChunkProperties();
              customToast(
                `Filename exceeded more than 100 character. Please rename the file.`,
                "critical"
              );
              break;
            } else {
              setShowRetry(false);
              resetChunkProperties();
              setShowReset(false);
              stopUpload.current = true;
              resetFileUpload();
              customToast(`${fileNameUpload} Upload Failed!`, "critical");
              break;
            }
          }
        }
      }
    }
  };

  // const getFormattedDateTime = () => {
  //   const now = new Date();

  //   const year = now.getFullYear();
  //   const month = String(now.getMonth() + 1).padStart(2, "0"); // Month is zero-based
  //   const day = String(now.getDate()).padStart(2, "0");
  //   const hours = String(now.getHours()).padStart(2, "0");
  //   const minutes = String(now.getMinutes()).padStart(2, "0");
  //   const seconds = String(now.getSeconds()).padStart(2, "0");

  //   const formattedDateTime = `${year}${month}${day}_${hours}${minutes}${seconds}`;

  //   return formattedDateTime;
  // };

  // const processDownloadedChunk = async (
  //   chunksArr: any,
  //   receLen: any,
  //   fileName: string
  // ) => {
  //   let chunksAll = new Uint8Array(receLen);
  //   let position = 0;
  //   for (let chunk of chunksArr) {
  //     chunksAll.set(chunk, position);
  //     position += chunk?.length;
  //   }

  //   const blob = new Blob([chunksAll]);
  //   const urlObject = URL.createObjectURL(blob);

  //   // Create a link and click it to start the download
  //   const link = document.createElement("a");
  //   link.href = urlObject;
  //   link.download = fileName;
  //   props.setDownloadProgress(false);
  //   props.setSelectedRow([]);
  //   props.setDisablefunc(true);
  //   props.setDownHandelClick(false);
  //   props.resetChunkProperties();
  //   customToast(`File Downloaded!`, "success");
  //   link.click();
  //   // refreshCurrentPageOfTable();
  //   setTimeout(() => URL.revokeObjectURL(urlObject), 60 * 1000);
  // };

  const initiateDownload = async (data: any) => {
    const csrfVal: any = cookieVal();
    try {
      // post request to download file
      const response: any = await downloadRecordsFetchCall(data, csrfVal);

      if (!response.ok) {
        if (response.status === 403) {
          resetChunkProperties();
          setDisablefunc(true);
          setRetryCountDownload(0);
          customToast(
            "Previous Download is in progress. Please try again after sometime",
            "critical"
          );
        } else if (response.status === 413) {
          resetChunkProperties();
          setDisablefunc(true);
          setRetryCountDownload(0);
          customToast(
            "Total size of files selected for download cannot exceed 2 GB",
            "critical"
          );
        } else {
          customToast(
            "Something went wrong, please try after sometime",
            "critical"
          );
          if (retryCountDownload < 5) {
            setRetryCountDownload(retryCountDownload + 1);
            hideRetryBtnState(false);
          } else {
            setDisablefunc(true);
            setRetryCountDownload(0);
            resetChunkProperties();
          }
        }
        // alert(`HTTP error! status: ${response.status}`);
        return;
      }
      const blobReader = response.body.getReader();
      let contLen = +response.headers.get("Content-Length");
      let receiveLen = 0;
      let chunk: any = [];
      if (data.startRange === 0) {
        setContentLength(contLen);
        setReceivedLength(receiveLen);
        setChunks(chunk);
      } else {
        contLen = contentLength;
        receiveLen = receivedLength;
        chunk = chunks;
      }

      while (receiveLen !== contLen) {
        const { done, value } = await blobReader.read();
        if (done) {
          return;
        } else {
          chunk = [...chunk, value];
          receiveLen += value?.length;
          setProgressDownload(Math.round((receiveLen / contLen) * 100));
          if (receiveLen === contLen) {
            const fileName = "DP_DOWNLOAD_" + getFormattedDateTime() + ".zip";
            processDownloadedChunk(chunk, receiveLen, fileName, {
              setDownloadProgress,
              setSelectedRow,
              setDisablefunc,
              setDownHandelClick,
              resetChunkProperties,
            });
            setReceivedLength(0);
            setChunks(0);
            setDisablefuncUpload(false);
            // setDom(!dom);
          } else {
            setReceivedLength(receiveLen);
            setChunks(chunk);
          }
        }
      }
    } catch (error) {
      if (retryCountDownload < 5) {
        customToast("File download Failed! Please Retry.", "critical");
        setRetryCountDownload(retryCountDownload + 1);
        hideRetryBtnState(false);
      } else {
        customToast("File download Failed!", "critical");
        // setDisablefunc(true);
        resetChunkProperties();
      }
    }
  };

  useEffect(() => {
    if (downHandelClick) {
      handletoastdownload();
    }
  }, [downHandelClick]);
  useEffect(() => {
    if (
      searchStatus === 200 &&
      Array.isArray(searchList) &&
      searchList.length > 0
    ) {
      setFilteredGridData(searchList);
      setIsSearchDataEmpty(false);
      setLoadingPage(false);
    } else if (
      searchStatus === 200 &&
      Array.isArray(searchList) &&
      searchList.length === 0
    ) {
      setFilteredGridData([]);
      setIsSearchDataEmpty(true);
      setLoadingPage(false);
    } else if (searchStatus !== 200) {
      // setFilteredGridData([]);
      // setIsSearchDataEmpty(true);
      setLoadingPage(false);
    }
  }, [searchList, searchStatus]);

  // Handle Enter key press in search
  const handleSearchInput = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (
      e.key === "Enter" &&
      searchData.current.trim() !== "" &&
      !searchError.current
    ) {
      // Dispatch your action here, e.g.:
      setLoadingPage(true);
      dispatch(
        getSearchData({
          searchFileName: searchData.current,
          // orgId: props.orgId,
          accessToken: localStorage.getItem("access_token"),
          siteId: siteid.current,
        })
      );
      // Optionally blur the input
      (e.target as HTMLInputElement).blur();
    }
  };

  const handletoastdownload = () => {
    setChunks([]);
    setReceivedLength(0);
    hideRetryBtnState(true);
    setProgressDownload(0);
    setContentLength(0);
    if (downloadSelectedRowData?.length > 0 && receivedLength === 0) {
      setLoadingPage(true);
      setTimeout(() => {
        realDownload();
      }, 500);
      // await dispatch(downloadRecordFile({ authorization: localStorage.getItem('access_token'), param: data, siteid: siteId }))
    } else {
      // ReactToastify.toast(<ToastNotification />)
      customToast("Please select file name", "critical");
    }
  };

  const realDownload = async () => {
    try {
      if (downloadSelectedRowData?.length > 0) {
        const resultArr = downloadSelectedRowData.map(
          (item: any, index: any) => {
            // item.fileName ? setFileName(item.fileName) : setFileName("");
            let currentPath = `${finallist.join("/")}/`;
            let currFolder = item.path.replace(
              new RegExp(`^${currentPath}\\s*`),
              ""
            );
            let _currTopLevelFolder = currFolder.split("/").filter(Boolean)[0];
            return {
              path: item.path
                ? item.fileType === "folder" && isSearchDataEmpty
                  ? (currentPath !== "/" ? currentPath : "") +
                    _currTopLevelFolder
                  : item.path
                : "",
              fileName: item.fileName
                ? !isSearchDataEmpty
                  ? item.fileName
                  : item.fileType !== "folder"
                  ? item.fileName
                  : ""
                : "",
            };
          }
        );
        const data = {
          container: downloadSelectedRowData[0].containerName
            ? downloadSelectedRowData[0].containerName
            : "",
          // 'updatedBy': downloadSelectedRowData[0]?.updatedBy ? downloadSelectedRowData[0]?.updatedBy : '',
          downloadfilesmodel: resultArr,
        };
        setDownloadProgress(true);
        setSelectedRow([]);
        setLoadingPage(false);
        hideRetryBtnState(true);
        setDisablefuncUpload(true);
        await initiateDownload({
          authorization: localStorage.getItem("access_token"),
          param: data,
          siteId: siteId,
          startRange: receivedLength,
        });
      }
    } catch (error) {
      setDownloadProgress(false);
      setSelectedRow([]);
      customToast(
        "Unable to download the selected file, please try after sometime",
        "critical"
      );
    }
  };

  return (
    <>
      <HeaderComponent />
      <div className="extended-container">
        {loading ? (
          <Loader overlayColor="#a0a0a0">
            <div className="placeholder" />
          </Loader>
        ) : (
          ""
        )}
        <div className="bread-crumb-container">
          <Breadcrumb>
            <Breadcrumb.Item
              data-testid="navigate-datamgmt"
              onClick={() => navigateToDashboard(orgNameVal)}
            >
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item
              data-testid="navigate-datamgmt-1"
              onClick={() => navigateToDashboard(orgNameVal)}
            >
              {orgNameVal}
            </Breadcrumb.Item>

            <Breadcrumb.Item
              data-test="navigate-datamgmt"
              data-testid="navigate-datamgmt-test"
              onClick={() => navigateToDatamanagement(xval)}
            >
              {" "}
              Data Management
            </Breadcrumb.Item>

            {finallist?.map((item: any, index: any) => {
              return (
                <Breadcrumb.Item
                  data-testid="navigate-datamgmt-test-with-in"
                  onClick={() => navigateToPreviousPage(item, xval, index)}
                  key={item + index}
                >
                  {item}
                </Breadcrumb.Item>
              );
            })}
          </Breadcrumb>
        </div>
        {consumedBlobState > 0 && (
          <div className="status-bar">
            <span className="storage-text">{"Storage space :"}</span>
            <div className="progress-dm">
              <Progress
                value={consumedBlobState}
                total={AllocatedSize}
                showProgress={false}
                size="xxsmall"
                percent={(consumedBlobState / AllocatedSize) * 100}
              />
              <span className="htag">
                {blobSizeState?.message?.consumedSize} of{" "}
                {blobSizeState?.message?.allocatedSize}
                {"(" +
                  ((consumedBlobState / AllocatedSize) * 100).toFixed(2) +
                  "%)"}
              </span>
            </div>
          </div>
        )}
        <div style={{ border: "2px solid #303030", position: "relative" }}>
          <div>
            <div>
              <DataManagementGridNew
                {...{
                  finallist,
                  xval,
                  newFileKey,
                  inputEle,
                  newArr,
                  selectedRowData,
                  selectedRow,
                  isNewFolderBtnDisabled,
                  showProgress,
                  showReset,
                  disablefuncupload,
                  disablefunc,
                  orgData,
                  orgId,
                  setLoadingPage,

                  // Methods
                  setSelectedRow,
                  setSelectedRowData,
                  setDownloadSelectedRowData,
                  setDisablefunc,
                  setDisablefuncUpload,
                  setIsNewFolderBtnDisabled,
                  setxval,

                  // reset
                  setfileKey,
                  handlechangelink,
                  setemptyFldrName,
                  setFexist,
                  dateFormatFun,
                  setNameLength,
                  setNewArr,
                  setDeleteOpen,
                  eventBeforeUploadApi,
                  refreshCurrentPageOfTable,
                  fileInputRef,
                  setShowPopup,

                  // search
                  setFilteredGridData,
                  filteredGridData,
                  setIsSearchDataEmpty,
                  isSearchDataEmpty,
                  setSearchValue,
                  searchValue,

                  // download
                  showDownloadProgress,
                  setDownHandelClick,
                  searchError,
                }}
              />
              <div className="footer table-wrapper-custom">
                {
                  <div className="progress-bar">
                    <div className="progress-div">
                      {(showDownloadProgress ||
                        showProgress ||
                        !retryBtnState) && (
                        <div className="fileupload-progressbar">
                          {showDownloadProgress || showProgress ? (
                            <Progress
                              value={
                                showDownloadProgress
                                  ? progressDownload
                                  : progress
                              }
                              total={100}
                              size="xsmall"
                              showProgress={true}
                            ></Progress>
                          ) : null}
                          <span className="inprogresstext">
                            {showDownloadProgress
                              ? `File download in-progress`
                              : `${fileNameUpload} upload in-progress (${
                                  progress % 1 === 0
                                    ? progress
                                    : progress?.toFixed(2)
                                } %)`}
                          </span>
                        </div>
                      )}
                    </div>
                    <div className="icon-div">
                      {!retryBtnState && (
                        <Icon
                          className="retry-icon"
                          root="global"
                          name="redo"
                          size="medium"
                          onClick={() => realDownload()}
                        />
                      )}
                      <span className="inprogresstext">
                        {showReset === true &&
                        showRetry === false &&
                        showProgress === false
                          ? `${fileNameUpload} upload failed. Please cancel to upload again.`
                          : null}
                      </span>
                      {showRetry && (
                        <Tooltip
                          content="Retry upload"
                          element={
                            <Icon
                              className="retry-icon"
                              root="global"
                              name="redo"
                              size="medium"
                              onClick={uploadFile}
                            />
                          }
                        />
                      )}
                      {showReset && (
                        <Icon
                          className="resetbtn"
                          root="global"
                          name="close"
                          size="medium"
                          onClick={resetFileUpload}
                        />
                      )}
                    </div>
                  </div>
                }
              </div>

              <DeleteFilePopup
                {...{
                  deletePopOpen,
                  setDeleteOpen,
                  handleDeleteApiFinalCall,
                }}
              />
              <FileExistPopup {...{ fexist, setFexist, inputEle }} />
              <FileValidatePopup
                {...{
                  uploadValidateOpen,
                  setUploadValidateOpen,
                  // uploadValidationPopupEvent,
                  uploadFile,
                  resetFileInput,
                  rowKey,
                  setFileNameUpload,
                }}
              />
              <FolderNotEmptyPopup
                {...{
                  emptyFldrName,
                  setemptyFldrName,
                  inputEle,
                  // folderNameCantBeEmptyEvent,
                }}
              />
              <NameLengthExceededPopup
                {...{ nameLength, setNameLength, resetChunkProperties }}
              />
              <UploadNotePopup
                {...{ showPopup, setShowPopup, handleConfirmUpload }}
              />
              <SymlinkErrorPopup
                {...{
                  symlinkError,
                  setSymlinkError,
                  handleSymlinkErrorPopup,
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
